import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary as InternalErrorBoundary, SHELL_ID, getComponentName, } from "@aviv-unified-frontend/internal";
import { GeneralErrorPage } from "../../pages/errors";
import { logger } from "../../utils/logger";
export const ErrorBoundary = ({ name, children }) => (_jsx(InternalErrorBoundary, { id: `${SHELL_ID}_${name}`, onError: logger.error, fallback: GeneralErrorPage, children: children }));
export const withErrorBoundary = (errorBoundaryProps) => (Component) => {
    const WrappedComponent = (props) => (_jsx(ErrorBoundary, { ...errorBoundaryProps, children: _jsx(Component, { ...props }) }));
    WrappedComponent.displayName = `WithErrorBoundary(${getComponentName(Component)})`;
    return WrappedComponent;
};
